import React from 'react';
import { NavLink } from 'react-router-dom';

import Icon from '@components/custom/Icon';
import ModuleHeader from '@components/ModuleHeader';

import { REPORT_TYPES } from '@modules/generateReport/GenerateReport';
import { useCheckPageAccess } from '@sm/hooks/useCheckPageAccess';

const Footer = () => {
  const links = [{
    id: 'currency_exchange',
    title: 'Transactions',
    reportType: REPORT_TYPES.DEPOSITS_PAYOUTS,
    hasAccess: useCheckPageAccess('REPORTS_MERGED')
  }, {
    id: 'balance',
    title: 'Running Balance',
    reportType: REPORT_TYPES.RUNNING_BALANCE,
    hasAccess: useCheckPageAccess('REPORTS_RUNNING_BALANCE')
  }, {
    id: 'assured_workload',
    title: 'Settlement',
    reportType: REPORT_TYPES.SETTLEMENTS,
    hasAccess: useCheckPageAccess('REPORTS_SETTLEMENTS')
  }, {
    id: 'monitoring',
    title: 'Performance',
    reportType: REPORT_TYPES.PERFORMANCE,
    hasAccess: useCheckPageAccess('REPORTS_PERFORMANCE')
  }, {
    id: 'receipt_long',
    title: 'Statements',
    reportType: REPORT_TYPES.CLOSING_BALANCE,
    hasAccess: useCheckPageAccess('REPORTS_CLOSING_BALANCE')
  }, {
    id: 'send_money',
    title: 'OTC',
    reportType: REPORT_TYPES.OTC_SETTLEMENTS,
    hasAccess: useCheckPageAccess('REPORTS_OTC_SETTLEMENT')
  }];

  return (
    <div className='col-12 footer shadow'>
      <div className='row'>
        <div className='col'>
          <ModuleHeader id='article' title='Reports' />
        </div>
      </div>
      <div className='row links'>
        {links.map((link, index) => {
          return link.hasAccess && (
            <div key={ index } className='col-6 col-lg-2'>
              <NavLink
                to={ `/generate-reports` }
                className='item'
                state={ { report: link.reportType } }
              >
                <Icon name={ link.id } size={ 36 } />
                {link.title}
              </NavLink>
            </div>
          );}
        )}
      </div>
    </div>
  );
};

export default Footer;